import { getNestedProperty } from './getNestedProperty';
import { toJS } from './toJS';
export const getFilters = (values, state) => {
  const filterName = getNestedProperty('filterName', values);
  const data = getNestedProperty('filter.data', state, {});
  const dataFilter = filterName && toJS(data)[filterName];
  const filters = dataFilter || '';
  return filters;
};
